import { FFAuthLayoutFooter } from '../../../../customized/fours-fringand-fr/components/auth/AuthLayout/AuthLayoutFooter/FFAuthLayoutFooter';
import FWAuthLayoutFooter from '../../../../customized/fresh-watch/components/auth/AuthLayout/AuthLayoutFooter';
import { ToggleComponent } from '../../../../featureToggle';
import { AuthLayoutFooter } from './AuthLayoutFooter';

export default ToggleComponent(AuthLayoutFooter, {
  styledComponentsVariants: {
    'fresh-watch': FWAuthLayoutFooter,
    'fours-fringand-fr': FFAuthLayoutFooter,
  },
});
